const getCSSVars = (prop) => {
	const root = document.documentElement;
	const styles = getComputedStyle(root);
	const value = styles.getPropertyValue(`--${prop}`).trim();
	return value;
};

export default getCSSVars;
